/**
 * Company initials for the switch avatar. Deliberately NOT `@/shared/utils/getInitials` —
 * that one is a person-name rule (one letter per word) and "Galp" must render "GA", not "G".
 */
export const getCompanyInitials = (name: string | null | undefined): string => {
	const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
	if (words.length === 0) return '';
	if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
	return `${words[0]![0]}${words[1]![0]}`.toUpperCase();
};
